import fetch from 'node-fetch'

const endpointURL = process.env.GATSBY_LAMBDA_ROUTE

export const sendRequest = async (values, path) => {
  try {
    const response = await fetch(`${endpointURL}/${path}`, {
      method: 'post',
      body: JSON.stringify(values),
    })

    const data = await response.json()
    if (data.result) {
      return data.message
    }
    throw data.message
  } catch (error) {
    throw new Error('There was an error submitting your information. Please try again or contact us directly at hi@versett.com.')
  }
}
